{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "KFC",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              },
              {
                "id": "Dineout",
                "title": "Dineout",
                "cta": "https://swiggy.com/menu/588619/dineout"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "588619",
              "name": "KFC",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "kfc-brigade-road-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/10/17/6d3d13fc-24a0-4e43-a672-9c3e35b65fea_588619.JPG",
              "locality": "Brigade Road",
              "areaName": "Central Bangalore",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": ["Burgers", "Fast Food"],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "588619",
                "fees": [{}]
              },
              "parentId": "547",
              "avgRatingString": "4.3",
              "totalRatingsString": "3.1K+ ratings",
              "sla": {
                "restaurantId": "588619",
                "deliveryTime": 44,
                "minDeliveryTime": 40,
                "maxDeliveryTime": 45,
                "lastMileTravel": 5.6,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "40-45 MINS",
                "lastMileTravelString": "5.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2025-10-22 01:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {}
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 119",
                "shortDescriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "BXGY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "BXGY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {},
              "slugString": "kfc-brigade-road-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Ground Floor & 1st Floor, Brigade Rd, Opposite Space Centre, Shanthala Nagar, Ashok Nagar, Bengaluru, Karnataka 560029"
                },
                {
                  "title": "Cuisines",
                  "message": "Burgers,Fast Food"
                }
              ],
              "totalRatings": 3100,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 119",
                "shortDescriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "BXGY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "BXGY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 10,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 700
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {}
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/588619"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {},
                "commsStyling": {}
              },
              "nearestOutletNudge": {
                "nearestOutletInfo": {
                  "siblingOutlet": {
                    "id": "17304",
                    "city": "0",
                    "slugs": {},
                    "areaName": "R T Nagar",
                    "costForTwo": "0",
                    "feeDetails": {},
                    "sla": {
                      "deliveryTime": 30,
                      "lastMileTravel": 3,
                      "slaString": "30 MINS",
                      "lastMileTravelString": "3.0 km",
                      "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                      "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                      "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                      "visible": true
                    },
                    "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                    "cartOrderabilityNudgeBanner": {
                      "parameters": {},
                      "presentation": {}
                    },
                    "featuredSectionInfo": {}
                  }
                },
                "nearestOutletComms": {
                  "title": {
                    "text": "Get your order 14 min faster"
                  },
                  "subTitle": {
                    "text": "Switch to the faster outlet"
                  }
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {},
                "presentation": {}
              },
              "latLong": "12.9733532,77.6075238",
              "backgroundImageOverlayInfo": {},
              "featuredSectionInfo": {},
              "requestContexts": ["99store", "enable_ecosaver"],
              "dishStyle": {
                "socialMarkerStyle": [
                  {
                    "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                    "title": "Protein Rich",
                    "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                    "textColor": "highlight"
                  },
                  {
                    "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                    "title": "Bestseller",
                    "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                    "textColor": "color_swiggy_one"
                  }
                ]
              }
            },
            "analytics": {}
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {},
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹119",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["e5dc8b2c-49a2-4ad6-a124-b668dc21ca45"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "588619",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "BUY 2 GET 1 FREE",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["c963c647-d991-4cb1-8a6e-7bce72f9fccc"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE BUY2GET1",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "588619",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE BUY2GET1"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["c3b0b1c6-090c-4fc4-a0ae-9d07eb0a8299"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAVORFUL",
                      "description": "ABOVE ₹899",
                      "offerType": "offers",
                      "restId": "588619",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAVORFUL"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 20% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["df32d376-8716-442f-8e43-bceb4ed889b7"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE XTRAPARTY",
                      "description": "ABOVE ₹2999",
                      "offerType": "offers",
                      "restId": "588619",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE XTRAPARTY"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/8/20/c812c78a-7809-4ffa-9eea-59482c5bac46_RuPay.png",
                      "offerIds": ["aad6b5b0-cd9c-4e28-b967-f72aae66b6f3"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAYCC100",
                      "description": "ABOVE ₹600",
                      "offerType": "offers",
                      "restId": "588619",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/8/20/c812c78a-7809-4ffa-9eea-59482c5bac46_RuPay.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE RUPAYCC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {}
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {}
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {},
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "Buy 2 Get 1"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936697",
                              "name": "Choco Lava Festive Hamper (4 Pcs",
                              "category": "DIWALI FESTIVE HAMPER",
                              "description": "Dive into molten happiness! Four rich, gooey Choco Lava cakes — perfectly baked with a molten chocolate core. The ultimate festive treat for every chocoholic.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47600,
                              "finalPrice": 37500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "2c7fbcff-5bec-4fc5-9160-e516d3ac8e99"
                              ],
                              "parentId": "112339001"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936696",
                              "name": "Snickers Choco Mousse Cake Festive Hamper (4 Pcs",
                              "category": "DIWALI FESTIVE HAMPER",
                              "description": "Indulge in pure decadence with four slices of Snickers-inspired Choco Mousse Cake — a dreamy blend of caramel, peanuts, and velvety chocolate mousse. Made to sweeten your celebrations!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/89c329bf-a91a-43b8-98a4-6c07ebf9b9ba_55a0e8bb-0f7f-402e-a244-76d4a0d1f35e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 55600,
                              "finalPrice": 43900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "7fe40e42-2239-434a-a4c3-29cefdae042c"
                              ],
                              "parentId": "112339004"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566899",
                              "name": "Craving Saving meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Crave & Save whooping Rs 249 on 4 Pc Hot & Crispy, 4 Pc Peri Peri Strips, Medium Popcorn, 2 Dips & a Pepsi PET 475ml [Serves 2-3]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/9e5902f5-c942-4371-99cf-433bee88b8db_5463d28f-6503-4666-af67-419ebe262289.jpg",
                              "inStock": 1,
                              "price": 77900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420257"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566898",
                              "name": "Party Bucket Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Party time Savings of Rs 92 on 4 Pc Peri Peri Chicken Leg Pc, 2 Pc Peri Peri Strips, Regular Popcorn & a Pepsi PET 475ml [Serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/6c1b2981-60c2-4bcf-8566-002519dccca1_67401533-ea91-49bd-9320-e55d22ae31f3.jpg",
                              "inStock": 1,
                              "price": 64900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420265"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566897",
                              "name": "Insta Reel Korean Roll Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Flat Rs 95 off on Tangy Korean Chicken Roll, 2 Pc Hot & Crispy, 7Up Zero Sugar Can 330ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a1ef4f33-ccae-4da1-b14e-d898046e4d8a_90e183d8-2b73-4edc-9fb1-1e70ea37df70.jpg",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288105",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288106",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288107",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288108",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420259"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566896",
                              "name": "Night Owl Roll combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Eye opener deal on Classic Chicken Roll & Medium Fries [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/eb4bf183-297e-4c7a-82db-6d2e0f787472_324a0669-3780-43d0-bfb3-2ff3483188c3.jpg",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288645",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288646",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288651",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288653",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420263"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566894",
                              "name": "Peri Peri Binge Watch combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Binge & Save Rs 85 on 4 Pc Peri Peri Leg pc, 2 Pc Peri Peri Strips & Regular Popcorn",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/5399c2df-c3d8-4d02-b45b-97d662ac7a57_84ef2049-345c-4aa4-ac20-92b3e5f32b61.jpg",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420266"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566892",
                              "name": "Night Shift Zinger Pro Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Relax in Night shift and save Rs 75 on Zinger Pro Burger, Large Popocorn and 7Up Zero Sugar Can 330ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/cc6054ae-054d-4302-8571-9373979b7360_63d88114-28d3-47c6-a6b5-add97c8d97c1.jpg",
                              "inStock": 1,
                              "price": 48900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288548",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288550",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288554",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288556",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420264"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566890",
                              "name": "Midnight Spicy Zinger & Popcorn Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Midnight special savings of Rs 85 on Spicy Zinger, Large Popcorn and Pepsi Black Can 330ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/42e73ea0-0d4f-46b7-a179-ea106f37e874_9d4136ac-02c6-4fa9-a97e-5d9886412209.jpg",
                              "inStock": 1,
                              "price": 45900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245945186",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945190",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585475",
                                      "name": "Double Chicken Roll",
                                      "price": 16900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945193",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945199",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420261"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566887",
                              "name": "Night Bite Veg Roll combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Munching deal of Rs 59 on Veg Spicy Roll & Large Fries [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a39e1ee7-7f57-460a-aff5-e568c6c25b18_fa010fd0-0059-4be3-b193-6a4103fca417.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290885",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290886",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290887",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290889",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420262"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566886",
                              "name": "Still Awake Veg Zinger Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Special Veg deal with Rs 105 off on Veg Zinger Burger, Large Fries & a Pepsi Black Can 330ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/12/552c36a5-a81e-4ef2-b204-40a4d7ba63e0_c6ce48d6-f384-4ee0-9cd2-7380c77a0883.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247287787",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287789",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287793",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287796",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420269"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406705",
                              "name": "Korean & Thai Roll Chicken Meal",
                              "category": "ROLLS",
                              "description": "Rs 154 Off on Korean Tangy Roll & Thai Spicy Roll, Large Popcorn, Large Fries & Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/76d3e89f-2eec-4a04-8c0d-bd82bf153d78_6b7961a1-5a28-482a-a58d-c8e3c03fe112.jpg",
                              "inStock": 1,
                              "price": 56900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245946024",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946028",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946032",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492358"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406704",
                              "name": "Indian Tandoori Roll Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 85 on Indian Tandoori Roll, Classic Zinger Burger, Medium Fries & Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/6b6f3b25-fed1-4e21-afa4-0810da0f2059_b7efdb4b-1568-47b0-9432-1030f6e7ea31.jpg",
                              "inStock": 1,
                              "price": 41900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288462",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288465",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288468",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288471",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492355"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406703",
                              "name": "Korean Tangy Roll & Popcorn Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 76 with Korean Tangy Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/213c8941-ef28-41f5-b4b3-81d1d7dc785d_2ddc27a9-dbf7-4164-84c7-06b2e079b10a.jpg",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290850",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290852",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290854",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290855",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492356"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406702",
                              "name": "Thai Spicy Roll & Zinger Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 85 with Thai Spicy Roll with Classic Zinger Burger, Medium Fries and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/e8d6de01-a6aa-47df-b0c8-6a580359d316_64860f8d-e6bc-4b84-8d79-62615f1f4aa4.jpg",
                              "inStock": 1,
                              "price": 41900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289288",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289291",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289292",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289295",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492360"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406701",
                              "name": "American Roll & Popcorn Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 76 with American Nashville Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/09f209e4-a89e-46f4-aec2-bc622f17bd92_d5c5ea67-e942-45ef-af85-655d3f891c90.jpg",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436061",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436065",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436069",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436070",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492354"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406700",
                              "name": "Thai Spicy Roll & Popcorn Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 76 with Thai Spicy Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/a0e77537-403f-4fd9-b657-005e878e2049_adf8a8b1-13ab-4056-af16-8e5a932402e4.jpg",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247006241",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006244",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006247",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006248",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492359"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406699",
                              "name": "Korean Tangy Roll & Zinger Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 85 with Korean Tangy Roll with Classic Zinger Burger, Medium Fries and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/11/bd3efed3-0c20-49ff-b3b4-f49cefb16358_d57b0b7a-b74b-49da-9865-2c65f1d0d65a.jpg",
                              "inStock": 1,
                              "price": 41900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005892",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005894",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005896",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005899",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492357"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145439514",
                              "name": "Korean Tangy Chicken Roll",
                              "category": "ROLLS",
                              "description": "Delicious new roll featuring tangy Korean kimchi, vegetables and crunchy chicken strips",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/25/2b5fdf7d-ee02-4871-8a5d-e766dc62833a_ae001a35-cbdc-4524-9868-b192251fda2b.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245946127",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946130",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946133",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946136",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "85985881"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145439513",
                              "name": "Thai Spicy Chicken Roll",
                              "category": "ROLLS",
                              "description": "Fresh burst of Thai flavours and sauces in a flaky paratha, chicken strips and vegetables",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/25/8de08e92-01c9-4325-a98e-2c069b933f50_b8af1bba-0784-4271-8243-11e0669e5af6.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288908",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288913",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288918",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288923",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "85985884"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {},
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "DIWALI FESTIVE HAMPER",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936697",
                              "name": "Choco Lava Festive Hamper (4 Pcs",
                              "category": "DIWALI FESTIVE HAMPER",
                              "description": "Dive into molten happiness! Four rich, gooey Choco Lava cakes — perfectly baked with a molten chocolate core. The ultimate festive treat for every chocoholic.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47600,
                              "finalPrice": 37500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "2c7fbcff-5bec-4fc5-9160-e516d3ac8e99"
                              ],
                              "parentId": "112339001"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936696",
                              "name": "Snickers Choco Mousse Cake Festive Hamper (4 Pcs",
                              "category": "DIWALI FESTIVE HAMPER",
                              "description": "Indulge in pure decadence with four slices of Snickers-inspired Choco Mousse Cake — a dreamy blend of caramel, peanuts, and velvety chocolate mousse. Made to sweeten your celebrations!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/89c329bf-a91a-43b8-98a4-6c07ebf9b9ba_55a0e8bb-0f7f-402e-a244-76d4a0d1f35e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 55600,
                              "finalPrice": 43900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "7fe40e42-2239-434a-a4c3-29cefdae042c"
                              ],
                              "parentId": "112339004"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/89c329bf-a91a-43b8-98a4-6c07ebf9b9ba_55a0e8bb-0f7f-402e-a244-76d4a0d1f35e.jpg",
                      "categoryId": "67961950"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "LATE NIGHT SPECIALS (STARTING AT 199)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566899",
                              "name": "Craving Saving meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Crave & Save whooping Rs 249 on 4 Pc Hot & Crispy, 4 Pc Peri Peri Strips, Medium Popcorn, 2 Dips & a Pepsi PET 475ml [Serves 2-3]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/9e5902f5-c942-4371-99cf-433bee88b8db_5463d28f-6503-4666-af67-419ebe262289.jpg",
                              "inStock": 1,
                              "price": 77900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420257"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566898",
                              "name": "Party Bucket Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Party time Savings of Rs 92 on 4 Pc Peri Peri Chicken Leg Pc, 2 Pc Peri Peri Strips, Regular Popcorn & a Pepsi PET 475ml [Serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/6c1b2981-60c2-4bcf-8566-002519dccca1_67401533-ea91-49bd-9320-e55d22ae31f3.jpg",
                              "inStock": 1,
                              "price": 64900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420265"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566897",
                              "name": "Insta Reel Korean Roll Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Flat Rs 95 off on Tangy Korean Chicken Roll, 2 Pc Hot & Crispy, 7Up Zero Sugar Can 330ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a1ef4f33-ccae-4da1-b14e-d898046e4d8a_90e183d8-2b73-4edc-9fb1-1e70ea37df70.jpg",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288105",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288106",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288107",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288108",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420259"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566896",
                              "name": "Night Owl Roll combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Eye opener deal on Classic Chicken Roll & Medium Fries [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/eb4bf183-297e-4c7a-82db-6d2e0f787472_324a0669-3780-43d0-bfb3-2ff3483188c3.jpg",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288645",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288646",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288651",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288653",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420263"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566894",
                              "name": "Peri Peri Binge Watch combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Binge & Save Rs 85 on 4 Pc Peri Peri Leg pc, 2 Pc Peri Peri Strips & Regular Popcorn",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/5399c2df-c3d8-4d02-b45b-97d662ac7a57_84ef2049-345c-4aa4-ac20-92b3e5f32b61.jpg",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420266"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566892",
                              "name": "Night Shift Zinger Pro Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Relax in Night shift and save Rs 75 on Zinger Pro Burger, Large Popocorn and 7Up Zero Sugar Can 330ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/cc6054ae-054d-4302-8571-9373979b7360_63d88114-28d3-47c6-a6b5-add97c8d97c1.jpg",
                              "inStock": 1,
                              "price": 48900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288548",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288550",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288554",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288556",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420264"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566890",
                              "name": "Midnight Spicy Zinger & Popcorn Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Midnight special savings of Rs 85 on Spicy Zinger, Large Popcorn and Pepsi Black Can 330ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/42e73ea0-0d4f-46b7-a179-ea106f37e874_9d4136ac-02c6-4fa9-a97e-5d9886412209.jpg",
                              "inStock": 1,
                              "price": 45900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245945186",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945190",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585475",
                                      "name": "Double Chicken Roll",
                                      "price": 16900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945193",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945199",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420261"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566887",
                              "name": "Night Bite Veg Roll combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Munching deal of Rs 59 on Veg Spicy Roll & Large Fries [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a39e1ee7-7f57-460a-aff5-e568c6c25b18_fa010fd0-0059-4be3-b193-6a4103fca417.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290885",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290886",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290887",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290889",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420262"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566886",
                              "name": "Still Awake Veg Zinger Meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Special Veg deal with Rs 105 off on Veg Zinger Burger, Large Fries & a Pepsi Black Can 330ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/12/552c36a5-a81e-4ef2-b204-40a4d7ba63e0_c6ce48d6-f384-4ee0-9cd2-7380c77a0883.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247287787",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287789",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287793",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287796",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420269"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566895",
                              "name": "Rice Krunch Bowl Combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Krunchy savings of Rs 69 on Popcorn Chicken Rice Bowl and 4 Pc Peri Peri Strips [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/b328f1b1-ed4e-4a95-9a8f-f02b071f7388_d001011b-08b5-469d-8d8e-0bb9643002e7.jpg",
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436647",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436648",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436649",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436650",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 11 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420268"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566893",
                              "name": "Thai Roll Dream meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Dream deal of Rs 145 on 2 units of Thai Spicy Chicken Roll, 2 units of Popcorn Rice Bowl and a Pepsi PET 475ml [Serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/de2a7280-a059-40b1-9fda-8fef1a6b7660_e839fa2f-4777-4245-b109-2b7e8af9b997.jpg",
                              "price": 64900,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 11 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420270"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566891",
                              "name": "Rice & Bites combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Deal meal of Hot & Crispy Rice Bowl and Large Popcorn [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/bcceee6c-627d-4708-ace4-8838694bf483_becfb89e-9d3e-4b52-afa6-6582f7ecad5e.jpg",
                              "price": 44900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289372",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289376",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289379",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289382",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 11 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420267"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566889",
                              "name": "Gaming Night Korean Roll meal",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "Night fun savings of Rs 145 on 2 units of Korean Tangy Chicken Roll, 2 units of Popcorn Rice Bowl and a Pepsi PET 475ml [Serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/140c9f75-811e-4d67-983a-19bfee65a0d9_278fffa2-1500-4732-a139-309c5df2914d.jpg",
                              "price": 64900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436375",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436379",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436383",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436385",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 11 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420258"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150566888",
                              "name": "Lazy BFF Rice combo",
                              "category": "LATE NIGHT SPECIALS (STARTING AT 199)",
                              "description": "BFF deal savings of Rs 99 on 2 units of Popcorn Rice Bowl and 4 Leg Pc [Serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/bf86f1c9-3182-4189-9a35-8c5f2ad63ba0_d12d07c2-dc58-4ee8-b182-5b11f17f973e.jpg",
                              "price": 79900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288118",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288120",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288124",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288128",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 11 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89420260"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/9e5902f5-c942-4371-99cf-433bee88b8db_5463d28f-6503-4666-af67-419ebe262289.jpg",
                      "categoryId": "52917107"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "ROLLS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406705",
                              "name": "Korean & Thai Roll Chicken Meal",
                              "category": "ROLLS",
                              "description": "Rs 154 Off on Korean Tangy Roll & Thai Spicy Roll, Large Popcorn, Large Fries & Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/76d3e89f-2eec-4a04-8c0d-bd82bf153d78_6b7961a1-5a28-482a-a58d-c8e3c03fe112.jpg",
                              "inStock": 1,
                              "price": 56900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245946024",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946028",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946032",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492358"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406704",
                              "name": "Indian Tandoori Roll Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 85 on Indian Tandoori Roll, Classic Zinger Burger, Medium Fries & Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/6b6f3b25-fed1-4e21-afa4-0810da0f2059_b7efdb4b-1568-47b0-9432-1030f6e7ea31.jpg",
                              "inStock": 1,
                              "price": 41900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288462",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288465",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288468",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288471",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492355"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406703",
                              "name": "Korean Tangy Roll & Popcorn Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 76 with Korean Tangy Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/213c8941-ef28-41f5-b4b3-81d1d7dc785d_2ddc27a9-dbf7-4164-84c7-06b2e079b10a.jpg",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290850",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290852",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290854",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290855",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492356"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406702",
                              "name": "Thai Spicy Roll & Zinger Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 85 with Thai Spicy Roll with Classic Zinger Burger, Medium Fries and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/e8d6de01-a6aa-47df-b0c8-6a580359d316_64860f8d-e6bc-4b84-8d79-62615f1f4aa4.jpg",
                              "inStock": 1,
                              "price": 41900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289288",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289291",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289292",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289295",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492360"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406701",
                              "name": "American Roll & Popcorn Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 76 with American Nashville Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/09f209e4-a89e-46f4-aec2-bc622f17bd92_d5c5ea67-e942-45ef-af85-655d3f891c90.jpg",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436061",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436065",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436069",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436070",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492354"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406700",
                              "name": "Thai Spicy Roll & Popcorn Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 76 with Thai Spicy Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/a0e77537-403f-4fd9-b657-005e878e2049_adf8a8b1-13ab-4056-af16-8e5a932402e4.jpg",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247006241",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006244",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006247",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006248",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492359"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146406699",
                              "name": "Korean Tangy Roll & Zinger Chicken Meal",
                              "category": "ROLLS",
                              "description": "Save Rs 85 with Korean Tangy Roll with Classic Zinger Burger, Medium Fries and Pepsi PET 475ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/11/bd3efed3-0c20-49ff-b3b4-f49cefb16358_d57b0b7a-b74b-49da-9865-2c65f1d0d65a.jpg",
                              "inStock": 1,
                              "price": 41900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005892",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005894",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005896",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005899",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86492357"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145439514",
                              "name": "Korean Tangy Chicken Roll",
                              "category": "ROLLS",
                              "description": "Delicious new roll featuring tangy Korean kimchi, vegetables and crunchy chicken strips",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/25/2b5fdf7d-ee02-4871-8a5d-e766dc62833a_ae001a35-cbdc-4524-9868-b192251fda2b.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245946127",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946130",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946133",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245946136",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "85985881"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145439513",
                              "name": "Thai Spicy Chicken Roll",
                              "category": "ROLLS",
                              "description": "Fresh burst of Thai flavours and sauces in a flaky paratha, chicken strips and vegetables",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/25/8de08e92-01c9-4325-a98e-2c069b933f50_b8af1bba-0784-4271-8243-11e0669e5af6.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288908",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288913",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288918",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288923",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "85985884"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145439512",
                              "name": "Indian Tandoori Chicken Roll",
                              "category": "ROLLS",
                              "description": "Flavorful roll made with flaky lachha paratha, perfectly fried chicken strips in rich and creamy tandoori sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/4c966f38-c191-4d0e-a54c-c70b832e4de1_69ee13c1-f267-4385-ab98-6efbc811de33.jpg",
                              "inStock": 1,
                              "price": 12900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289399",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289407",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289411",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289417",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "85985879"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145439511",
                              "name": "Indian Spicy Veg Roll",
                              "category": "ROLLS",
                              "description": "Veg special spicy indian sauce and veggie roll",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/25/bf247176-6142-4eea-bd04-d0acf186b6f0_f5537093-5d29-4b12-9c71-7935995f15b8.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005981",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005983",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005986",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005988",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "85985878"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113953965",
                              "name": "Classic Chicken Roll",
                              "category": "ROLLS",
                              "description": "Street Syle Roll with Layerful parantha, single chicken strip, onions and two spicy sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/12/98809656-a56f-400b-a5f4-85da2c373728_1f87888c-7eeb-4dfe-b233-0588c8c7a99b.jpg",
                              "inStock": 1,
                              "price": 12900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005617",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005621",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005623",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005628",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "65630981"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113953964",
                              "name": "Double Chicken Roll",
                              "category": "ROLLS",
                              "description": "Double fun with double chicken strip filling, layerful parantha onions and two spicy sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/12/c51d83f6-4c85-477a-9262-204092ab3e91_d5f20a0c-8b5d-49a5-a178-ba8745b59ff1.jpg",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245945344",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945346",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945352",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945355",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657292"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/76d3e89f-2eec-4a04-8c0d-bd82bf153d78_6b7961a1-5a28-482a-a58d-c8e3c03fe112.jpg",
                      "categoryId": "39945772"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "FEASTIVAL MEALS (STARTING AT 259)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722060",
                              "name": "Chizza - Pizza with a KFC Twist",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Chicken fillet topped with cheese, sauce, veggies & herbs! All-chicken-no-crust pizza!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/f53e3412-545c-4e59-9fe5-c9a1799f6804_bbdc66cb-5101-4b2d-9b89-8b67067289aa.jpg",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222679"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722058",
                              "name": "Double Down",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "All chicken no bun burger with 2 delicious sauces & veggies [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/0f09e4c8-6053-40f1-a1a0-f7c9c9b85a48_e28e0d41-8971-4640-9dbe-8d9421dd7eb6.jpg",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "248951446",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "248951451",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "248951453",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "248951456",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "96779532"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722057",
                              "name": "2 Chizza - Pizza with a KFC Twist",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Save Rs. 19 on 2 Crunchy all-chicken-no-crust Chizza topped with cheese, spicy sauce, veggies & herbs [Serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/21cf58a5-d2db-45bf-9d60-f0e6886e2626_2bb84f50-946a-40fe-83e5-88b10df30cd5.jpg",
                              "inStock": 1,
                              "price": 57900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222675"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722056",
                              "name": "Chizza + Pepsi PET - Pizza with a KFC Twist",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/c2f9c0c2-451b-4ee5-961f-e9a9f87253f2_bffd060f-4226-486f-83b6-22f1fb04afe9.jpg",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222678"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722054",
                              "name": "Chizza+Med Fries+Pepsi PET-Pizza with a KFC Twist",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Save Rs 16 on Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml and Medium Fries [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/860307bf-2ed7-4964-ba5b-bb1a9f7ca2c9_ed714d19-c6a9-47b0-bc6a-b81248528f16.jpg",
                              "inStock": 1,
                              "price": 43900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222677"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722053",
                              "name": "2 Double Down",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Save Rs 19 on 2 Double Down - all chicken no bun Burgers [serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/a55a066a-7e8a-4094-98a9-56a11f0ba681_e38d19a3-8703-42b6-84e7-64064349bec0.jpg",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28656796"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722050",
                              "name": "Double Down + Pepsi PET",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "All chicken no bun burger with 2 delicious sauces & veggies served with Pepsi PET 475ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/c54c178e-3101-4dc8-a7e3-c23ea074467a_7cd9304b-3533-453b-bf06-23c4fc2b417f.jpg",
                              "inStock": 1,
                              "price": 30900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222681"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184722049",
                              "name": "Double Down + 1 Reg Popcorn + Pepsi PET",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Save Rs 12 on Double Down- all chicken no bun Burger, Regular Popcorn & Pepsi 475ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/19b573b2-0d28-494b-b95a-d5fa190afd5e_abecf5fa-6cfd-4977-b1a8-38b76b9af773.jpg",
                              "inStock": 1,
                              "price": 42900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222680"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "185040526",
                              "name": "Gold Chicken Zinger + Reg Fries",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Save Rs 59 on Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun and Fries on the side",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222683"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "185040525",
                              "name": "Gold Chicken Zinger + Reg Fries + Pepsi PET",
                              "category": "FEASTIVAL MEALS (STARTING AT 259)",
                              "description": "Save Rs 66 on Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun with Pepsi PET 475ml and Fries on the side [Serves 1]",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112222684"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/f53e3412-545c-4e59-9fe5-c9a1799f6804_bbdc66cb-5101-4b2d-9b89-8b67067289aa.jpg",
                      "categoryId": "67863089"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BURGERS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170989232",
                              "name": "Gold Edition - Chicken Zinger Burger & Fries",
                              "category": "BURGERS",
                              "description": "Relish our Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun with Pickles and Fries on the side",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/16/bcddd876-0931-48c8-85c7-e7affe150c54_266ea871-af0b-447c-bc3d-e21587368256.jpg",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245389134",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245389138",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245389140",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245389142",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103405118"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170989231",
                              "name": "Gold Edition - Veg Zinger Burger",
                              "category": "BURGERS",
                              "description": "Our Signature Veg Zinger Dunked in Cheese Sauce in the new Brioche Bun to get your tastebuds tingling",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/16/cb6e9c4a-4de6-4cb4-b549-35db959bf077_e7a57bea-8111-4037-8963-7275075500d2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247006219",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006222",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006224",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006226",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103405120"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173813555",
                              "name": "Chatpata Chana Veg Burger - 2 pc",
                              "category": "BURGERS",
                              "description": "Try New 2 units of Delicious Channa Burger with a unique Indian Chatpata Twist",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/8f55edec-e16c-4f68-985d-14a42e617527_f914dbc7-0a64-45c6-8a47-d603467a8776.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "finalPrice": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "6aa60287-99a5-40de-be57-34fee58925ef"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "107996512"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173813553",
                              "name": "2 x Chatpata Chana Veg Burger & Fries combo",
                              "category": "BURGERS",
                              "description": "Save Rs. 56 on 2 units of New Delicious Channa Burger with a unique Indian Chatpata Twist, Medium French Fries & 2 Dips",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/da7b540b-4bcf-4fc5-b764-1d63d4a6e84d_75a88c2c-bc58-4052-ae2f-6eea7e252f1f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "104913343"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173813551",
                              "name": "2 x Chatpata Chana Veg Burger Meal",
                              "category": "BURGERS",
                              "description": "Flat Rs 36 Off on 2 units of New Delicious Channa Burger with a unique Indian Chatpata Twist, Large Fries & Pepsi 475ml PET",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/c94d0023-5eaa-44f3-84bc-95f100530d3d_66f681f9-56e3-4a2f-8cc9-9b7dcf63e145.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "104913344"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122151318",
                              "name": "Spicy Zinger Burger and Popcorn Meal",
                              "category": "BURGERS",
                              "description": "Caribbean Spicy Zinger Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/9/37fde1f3-777c-48be-8d96-6c5b5d5de72a_14bce274-6cbc-432f-9f98-75000feb041b.jpg",
                              "inStock": 1,
                              "price": 44900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288734",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288737",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288742",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288745",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "70203436"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122227574",
                              "name": "Spicy Zinger Burger",
                              "category": "BURGERS",
                              "description": "Relish the Caribbean spicy zinger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/13/c399fbf4-8312-48c0-b661-fa2e052845cf_c96b26a6-55c6-43ff-8231-03e6c10cc4b6.jpg",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288877",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288880",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288882",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288884",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "93 ratings",
                                  "ratingCountV2": "93"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "70203434"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122151315",
                              "name": "Zinger Pro Burger & Popcorn Meal",
                              "category": "BURGERS",
                              "description": "New Zinger Pro burger with Medium Popcorn & Pepsi 475ml at a deal price",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/2/fa287588-7975-482c-9810-6931f5be4447_06ede9d3-51ef-4efd-877a-ddbb2f0ebebc.jpg",
                              "inStock": 1,
                              "price": 46900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436286",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436289",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436292",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436294",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "70203441"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122151304",
                              "name": "Zinger Pro Burger",
                              "category": "BURGERS",
                              "description": "Premium burger with crunchy chicken, Mexican Habanero sauce, cheese, tomato & onion",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/63e333fd-caa9-4032-9f1c-1799f26d5a45_2d9e58d4-6ad7-4acc-b58c-19f3f78acba9.jpg",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245945483",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945488",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487046",
                                      "name": "Smoky Red Grilled Chicken - 1 pc",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945493",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945496",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "56869955"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896523",
                              "name": "Chicken Burger Buddy Meal",
                              "category": "BURGERS",
                              "description": "Share 2 Classic Chicken Zingers & a Medium Popcorn in this delightful combo for 2",
                              "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                              "inStock": 1,
                              "price": 54900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245388792",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388793",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133670351",
                                      "name": "Chicken Zinger Burger - Tandoori",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388798",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388803",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "53127266"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896521",
                              "name": "Mixed Chicken Zinger Burger Doubles",
                              "category": "BURGERS",
                              "description": "Best-seller combo of classic chicken zinger & tandoori zinger",
                              "imageId": "dd434d7cd80de42b3d04cb979aeacb46",
                              "inStock": 1,
                              "price": 36900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289059",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289065",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289069",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289075",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "53127271"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237355",
                              "name": "Classic Zinger Mojito Combo",
                              "category": "BURGERS",
                              "description": "Get All New Mojito Reusable Bottle with Classic Chicken Zinger Burger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/7d614e39-2124-48f1-b1bf-36b74c880ac6_6898330c-b14e-489b-b3b9-985ab4b7b239.jpg",
                              "inStock": 1,
                              "price": 30800,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245087877",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087878",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087879",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087880",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "80357459"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122151297",
                              "name": "Chicken Zinger Burger - Classic with Cheese",
                              "category": "BURGERS",
                              "description": "Signature burger with a crunchy chicken fillet, cheese slice, veggies & a delicious mayo sauce",
                              "imageId": "418e7dc325cf65d7c1d9faab2e646421",
                              "inStock": 1,
                              "price": 23400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245388100",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388103",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388105",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388107",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "52 ratings",
                                  "ratingCountV2": "52"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "66599237"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122151293",
                              "name": "Chicken Zinger Burger - Tandoori with Cheese",
                              "category": "BURGERS",
                              "description": "Chicken zinger with aádelicious tandoori sauce & cheese slice",
                              "imageId": "7af6cdbf96ad445ebfce65f568fd0adf",
                              "inStock": 1,
                              "price": 24400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247287825",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287831",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287834",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287839",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "66599238"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137710712",
                              "name": "Paneer Zinger Burger",
                              "category": "BURGERS",
                              "description": "Relish the Indian paneer zinger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/56c5c073-4ac4-4c43-990e-16a558cf3877_87868b65-5a9c-4dd4-8f2e-e47ad6ee57d2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436408",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436411",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436413",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436416",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657650"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122151289",
                              "name": "Veg Zinger Burger with Cheese",
                              "category": "BURGERS",
                              "description": "Signature veg burger with crispy patties, cheese slice, veggies & a tangy sauce",
                              "imageId": "6d8c645fcd7d5368741ccc61933fafed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22400,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436534",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436538",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436541",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436546",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657964"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896518",
                              "name": "Chicken Zinger Burger - Classic",
                              "category": "BURGERS",
                              "description": "Relish the KFC Classic Zinger-lettuce, mayo & Zinger patty filled between",
                              "imageId": "d5bc5b32dd177f5f207cad66556a572b",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290744",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290745",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290746",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290747",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "495 ratings",
                                  "ratingCountV2": "495"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "53127268"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118353626",
                              "name": "Chicken Longer Burger & 2 Strips Combo",
                              "category": "BURGERS",
                              "description": "Longgg burger with crunchy chicken, onions & a punchy sauce , served with 2 peri peri chicken strips",
                              "imageId": "e344aa3aac91a825e9d0d0e3f60eda4b",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245087992",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087993",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087995",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087996",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "67864076"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121921486",
                              "name": "Veg Longer Burger - 2pc",
                              "category": "BURGERS",
                              "description": "The really long burger with Veg Patty, Onion, Lettuce and two sauces",
                              "imageId": "866ef0fcc37944827cf419f6d9783d97",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "finalPrice": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289529",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289533",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289535",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289539",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "4422186c-bc7d-426c-b98c-733059f5d502"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "107996514"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896519",
                              "name": "Chicken Zinger Burger - Tandoori",
                              "category": "BURGERS",
                              "description": "Grab Tandoori Zinger Burger with Onions & Tangy sauce",
                              "imageId": "im6rml9ioxkrjiafqyhw",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245087974",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087977",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087979",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245087981",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "104 ratings",
                                  "ratingCountV2": "104"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "53127270"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136669677",
                              "name": "2 Classic Chicken Krisper Burgers",
                              "category": "BURGERS",
                              "description": "2 units of delicious chicken value burgers featuring delicious sauce & 2 peri peri chicken strips",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/17/6170613a-c811-4615-933d-7f0bb52a05b6_4e8b26a4-cbc5-4b4f-b945-602a3edb0bb3.jpg",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "80357452"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896516",
                              "name": "Veg Krisper Burgers - 2pc",
                              "category": "BURGERS",
                              "description": "2 delicious veg value burgers - at a deal price",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/8/10aa0923-fbec-4185-996d-08d1f08f4c14_6e3d80d3-6ef1-4c46-b453-ba3ed706bfb9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "finalPrice": 11900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005928",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005930",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005935",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005940",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "e5dc8b2c-49a2-4ad6-a124-b668dc21ca45"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "107996513"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/16/bcddd876-0931-48c8-85c7-e7affe150c54_266ea871-af0b-447c-bc3d-e21587368256.jpg",
                      "categoryId": "39945767"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "ALL DAY LUNCH SPECIAL MEAL BOX (SAVE RS 115)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137433793",
                              "name": "All Chicken Box",
                              "category": "ALL DAY LUNCH SPECIAL MEAL BOX (SAVE RS 115)",
                              "description": "Save Rs 115 with special Chicken Box of 2 Pc Chicken Leg Pc, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/d389059e-c4e5-4b04-b4e5-4989a0599ff8_88bb15e9-b4ad-409f-816b-5b41c484c20f.jpg",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247006343",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006345",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006346",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006348",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28656924"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137433792",
                              "name": "Classic Zinger Box",
                              "category": "ALL DAY LUNCH SPECIAL MEAL BOX (SAVE RS 115)",
                              "description": "All new special Zinger Box with savings of Rs 86 on Classic American Zinger Burger, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/435ff114-9cc0-43bc-af9f-efecd249f098_83fac3c7-9c53-4e9f-85b3-37724f647539.jpg",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247006286",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006288",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006290",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247006293",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657248"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "142800876",
                              "name": "Roll Meal Box",
                              "category": "ALL DAY LUNCH SPECIAL MEAL BOX (SAVE RS 115)",
                              "description": "Save Rs 88 with special Roll Box Meal of a Classic Chicken Roll , 2 Pc Hot Wings, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/17/042acd2b-085f-4400-8b38-397dcb5a0aa1_fc1bae99-1e56-4a60-94d5-574f48e2c50c.jpg",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245714308",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714313",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714319",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714321",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "81363087"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137433790",
                              "name": "Veg Box Meal",
                              "category": "ALL DAY LUNCH SPECIAL MEAL BOX (SAVE RS 115)",
                              "description": "Enjoy special Veg Box Meal with savings of Rs 111 on Veg Zinger Burger, 2 Pc Veg patty, Medium Fries & a Pepsi PET 475ml [Serves 1]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/9/f92325b1-84f8-4e3d-ad6a-2b8bb5a377c2_3876238a-bc22-49ba-b10a-56e8d947b5ac.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289346",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636997",
                                      "name": "Indian Spicy Veg Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289353",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289357",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "80612599"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137433791",
                              "name": "Rice Box Meal",
                              "category": "ALL DAY LUNCH SPECIAL MEAL BOX (SAVE RS 115)",
                              "description": "Save Rs 106 with special Rice Box Meal of a Popcorn Rice Bowl, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1-2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/930821a8-05cd-4138-9322-6ec73b062028_6a395eea-3f19-4e48-8ed7-2b802d6e3d8d.jpg",
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290950",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290951",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290952",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290954",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657731"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/d389059e-c4e5-4b04-b4e5-4989a0599ff8_88bb15e9-b4ad-409f-816b-5b41c484c20f.jpg",
                      "categoryId": "47016581"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "142800875",
                              "name": "Peri Peri Chicken 5 Leg Piece Meal",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25% OFF)",
                              "description": "Save Rs 46 on Deal Bucket of 5 Spicy Peri Peri Leg Pieces, 1 Med Fries & a Pepsi PET 475ml [serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/17/5b8ef1ad-e639-4cc0-b27b-82d1e3eff5d3_f3ba29f9-2f81-4c93-8089-d7c3e1d38bd2.jpg",
                              "inStock": 1,
                              "price": 65900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245714559",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714561",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714565",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714570",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "65480597"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113591608",
                              "name": "Peri Peri 10 Pc Chicken Strips & 2 Dips",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25% OFF)",
                              "description": "Save 24% on 10 Spicy Peri Peri chicken boneless strips with 2 Dips",
                              "imageId": "a0feef07b2a9d72ba02f4a7d53e46948",
                              "inStock": 1,
                              "price": 52900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005715",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005719",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005720",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005722",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "65480594"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124525871",
                              "name": "Peri Peri Chicken 5 Leg Piece Bucket",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25% OFF)",
                              "description": "Deal Bucket of 5 Spicy Peri Peri Leg Pieces [serves 2]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/9/3351121e-2689-4b00-bc74-464301e587a5_5a78302c-4c7c-40e7-a5f9-5ce4f7b64348.jpg",
                              "inStock": 1,
                              "price": 62500,
                              "finalPrice": 44900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245715261",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715265",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715270",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715274",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "17bde296-2733-4dec-8a58-07ac89e33ac1"
                              ],
                              "parentId": "96153573"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896532",
                              "name": "Peri Peri Chicken Strips - 6 Pc",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25% OFF)",
                              "description": "Signature Chicken Strips sprinkled with Peri Peri- 6 Peri Peri Strips- Ultimate Snack!",
                              "imageId": "qsmfyjef2hbu05emuu2c",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288219",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288222",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288225",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288228",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "65480598"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/17/5b8ef1ad-e639-4cc0-b27b-82d1e3eff5d3_f3ba29f9-2f81-4c93-8089-d7c3e1d38bd2.jpg",
                      "categoryId": "44949358"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896506",
                              "name": "Chicken & French Fries Bucket",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Crowd-favorite combo of 2pc Hot & Crispy chicken with Medium Fries",
                              "imageId": "pasdg6owucvi23hcp9eb",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005819",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005822",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005823",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005826",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "63453066"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896502",
                              "name": "Chicken Popcorn & French Fries Bucket",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Relish the Snack Bucket with Large Chicken Popcorn & Medium size Fries",
                              "imageId": "raq6sxtwfb9fvbd6bakq",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436331",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436332",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436334",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436336",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "63453067"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237350",
                              "name": "Classic Zinger Pepsi Bottle Combo",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Get Pepsi 330ml Reusable Bottle with Classic Chicken Roll",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/46708834-f4b8-44a8-ac10-8ce89777e614_e94bf79c-1c49-4605-b8a4-d0cefb33c739.jpg",
                              "inStock": 1,
                              "price": 28900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245388951",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388952",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388954",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388958",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "80357460"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181067532",
                              "name": "Peri Peri Grand Feast",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "2 Peri Peri Leg + 4 Chicken Strip + 4 Wings + 1 Medium Popcorn + 1 Pepsi Pet + 2 Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/26/4fb2deec-954c-4714-ac2e-ebc50350714f_8ee0def8-b084-4103-84ba-245ac960b8f6.jpg",
                              "inStock": 1,
                              "price": 129800,
                              "finalPrice": 65000,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "746f8188-b0e7-42a9-8160-75c568791379"
                              ],
                              "parentId": "109887624"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179551347",
                              "name": "Classic Chicken Roll Feast",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Classic Chicken Roll + Medium Fries + Pepsi Reusable + 1 Tandoori Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/a802f6b2-107c-401c-abd1-7f44c281471a_ded2b388-234c-4460-801c-79e48af1e062.jpg",
                              "inStock": 1,
                              "price": 39800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "108679739"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179551346",
                              "name": "Double Chicken Roll Combo",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Double Chicken Roll + Fries Medium + Pepsi Reusable + 1 Tandoori Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/40900dc0-b26a-4f86-977c-a3a5d5a7014c_b5483bff-b5cb-46e3-82c0-9b03cce12673.jpg",
                              "inStock": 1,
                              "price": 45800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "108679741"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179551344",
                              "name": "Classic Chicken Roll & Popcorn Meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Classic Chicken Roll + Popcorn Regular + 1 Tandoori Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/309b0bef-f581-4a6b-87d7-5a9417d7549d_0b595344-c6e8-4c76-a43a-2adcb9c74b8d.jpg",
                              "inStock": 1,
                              "price": 33800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "108679740"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101516968",
                              "name": "Chicken Super Snacker Combo",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Save Rs 76 with best of snacks with a Medium Chicken Popcorn, 4 strips, 1 dip & a chilled Pepsi Black Can [serves 1-2]",
                              "imageId": "xpfkrnzizg80fvytwemn",
                              "inStock": 1,
                              "price": 45800,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005492",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005494",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005497",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005501",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "68874454"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181067533",
                              "name": "Fiery Indulgence Box",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "1 Peri Peri Leg + 2 Chicken Strip + 2 Wings + 1 Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/55d2e150-9cb4-422c-ad3d-ff8975a122d3_ec463855-f6f2-45de-b232-32fed0548aeb.jpg",
                              "inStock": 1,
                              "price": 45800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "109887623"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181067531",
                              "name": "Royal Crunch Meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "1 Peri Peri Leg + 1 Regular Popcorn + 2 Wings + 1 Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/3a9bd230-3fd4-4275-9ac0-ab8e62c6336f_b6f07050-2734-4ca6-990d-a59a5a9511e5.jpg",
                              "inStock": 1,
                              "price": 45800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "109887625"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181067530",
                              "name": "Signature Leg & Wing Box",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "2 leg pcs + 4 pcs wings + 1 Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/d0480eaa-7c37-4198-ae43-d0167a77a1af_e7f843ed-9f18-426d-ad29-4b41935e95c4.jpg",
                              "inStock": 1,
                              "price": 55800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "109887626"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "182689035",
                              "name": "Jumbo Zinger Meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "2 Classic Zinger + 2 Pepsi Resuable + 4 Peri Peri Strip + Large Fries+2 Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/53451ecd-2528-456f-a621-43d767ac3d1e_48fa9871-41b1-487e-ad8e-b58a140d08ca.jpg",
                              "inStock": 1,
                              "price": 139800,
                              "finalPrice": 70000,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "b842e94a-6985-4235-806c-2cd46b639fa6"
                              ],
                              "parentId": "110980018"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "182689033",
                              "name": "Mad Duo Meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "2 Peri Peri Leg + 4 Chicken Wings + Large Chicken Popcorn+Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/f8eaf25a-f309-49db-bd2e-2c1dc1c97889_465aa16e-2dfc-496f-bed6-20571978d83e.jpg",
                              "inStock": 1,
                              "price": 99800,
                              "finalPrice": 49900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c86701e1-abd2-4a4a-9a3a-a495f0055dd5"
                              ],
                              "parentId": "110967033"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "182689032",
                              "name": "Pure Veggie Bliss",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Veg Zinger with Cheese + Medium Fries + Pepsi Resuable + Choco Mud Pie + DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/62f28192-5433-4038-b685-9e6e4099ad6f_a5981c0f-e031-45ea-b7b7-98c5eb50777d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 79800,
                              "finalPrice": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "d3122a72-e3ed-41ba-82af-f5264b72710a"
                              ],
                              "parentId": "110967034"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896550",
                              "name": "Chicken Bucket for Two",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Flat Rs. 115 off on combo of 2pc Hot & Crispy, 2 pc Smoky Red Chicken & Large Popcorn",
                              "imageId": "wmn6qpsqazt1ln8hylum",
                              "price": 59900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005760",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005764",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005768",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005771",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54462648"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179551343",
                              "name": "Rice & Chicken Popcorn Delight Meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Plain Rice + Popcorn Regular + Pepsi Reusable",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/b57ba6f0-f9f9-4ad3-8f12-6cfc8d6bee82_62bf93b1-779d-41b9-8ecd-962e1ed02e89.jpg",
                              "price": 45800,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "108679747"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179551342",
                              "name": "Veg Rice & Patty Duo meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Plain Rice + 2 Veg patty + Pepsi Reusable",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/46e1c623-59f2-4d22-84dd-a1a48a7ed51f_3a060446-b50b-4cab-8f93-0f4fee08b669.jpg",
                              "isVeg": 1,
                              "price": 45800,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "108679748"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "182689034",
                              "name": "Thrice as Nice",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "3 Hot and Crispy + 3 Chicken Strip + 3 Wings + Large Chicken Popcorn",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/c85e26ed-57d7-45f9-92cf-20a6dfd53725_51e739a3-bfe4-4c11-9b72-61aa83879813.jpg",
                              "price": 129800,
                              "finalPrice": 65000,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "746f8188-b0e7-42a9-8160-75c568791379"
                              ],
                              "parentId": "110980019"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "182689031",
                              "name": "Full-on Bowl Meal",
                              "category": "EPIC VALUE MEALS FOR 1-2 (UP TO 22% OFF)",
                              "description": "Popcorn Chicken Rice Bowl + 1 Peri Peri Leg + 2 Chicken Wings + Pepsi Resuable + Tandoori DIP",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/068f54a8-f116-4cd0-a124-048686beb46f_6c001f7d-cdfe-4e17-9105-2b089e1fed40.jpg",
                              "price": 79800,
                              "finalPrice": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "d3122a72-e3ed-41ba-82af-f5264b72710a"
                              ],
                              "parentId": "110980017"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "wmn6qpsqazt1ln8hylum",
                      "categoryId": "44949357"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "EPIC SAVINGS BUCKET FOR 3-4 (UP TO 32% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "145480156",
                              "name": "Ultimate Savings Chicken Bucket",
                              "category": "EPIC SAVINGS BUCKET FOR 3-4 (UP TO 32% OFF)",
                              "description": "Savings of 32% on signature bucket of 4pc Hot & crispy chicken, 6 Pc Wings, 4 Chicken Peri Peri Boneless strips, 2 Dips (20 gms each) & a Pepsi PET 475ml [serves 2-3 ]\n",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/15/6d46d3fd-915a-4455-baa8-c7bfb9c8650e_7ddc5025-6401-4773-a1b6-491eb4d13c91.jpg",
                              "inStock": 1,
                              "price": 74900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289139",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289142",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289145",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289149",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "68874457"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117825877",
                              "name": "All in One Chicken Bucket",
                              "category": "EPIC SAVINGS BUCKET FOR 3-4 (UP TO 32% OFF)",
                              "description": "1 Leg, 1 Hot & Crispy, 2 Wings, 2 Strips, 1 Zinger Fillet, 3 Dips [20gm each] & 1 Pepsi 475 ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/514ac4ef-0ff9-4e78-b118-10ba644d54bb_5e50748c-fc45-4d11-be03-ace7d41abb10.jpg",
                              "inStock": 1,
                              "price": 57900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290780",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290782",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290784",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290786",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "68874452"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896544",
                              "name": "Big 12 - Chicken Bucket",
                              "category": "EPIC SAVINGS BUCKET FOR 3-4 (UP TO 32% OFF)",
                              "description": "6pc Hot & Crispy Chicken,6 Wings & 2 Dips(20gm each)",
                              "imageId": "yqxxwbdxoaconjcyb7ka",
                              "inStock": 1,
                              "price": 79900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005866",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005869",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005870",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005873",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54462645"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896546",
                              "name": "Big 8 - Chicken Bucket",
                              "category": "EPIC SAVINGS BUCKET FOR 3-4 (UP TO 32% OFF)",
                              "description": "2pc Hot & Crispy, 2 Strips & 4pc Smoky Red chicken",
                              "imageId": "yiozpo7vfq8t5s4hns1v",
                              "inStock": 1,
                              "price": 74900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288234",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288237",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288242",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288246",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55324928"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/8/15/6d46d3fd-915a-4455-baa8-c7bfb9c8650e_7ddc5025-6401-4773-a1b6-491eb4d13c91.jpg",
                      "categoryId": "44949356"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "FESTIVE PARTY BUCKET",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936695",
                              "name": "Big Feast Bucket",
                              "category": "FESTIVE PARTY BUCKET",
                              "description": "A feast made for sharing! 8 Hot & Crispy Chicken, 2 Large chicken popcorn & 4 signature dips — the ultimate indulgence.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/8282e629-3a22-45ca-a9fe-4eaed0639b2e_91bc2257-2f68-4958-9911-b07b31fc09b3.jpg",
                              "inStock": 1,
                              "price": 123714,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112338998"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936694",
                              "name": "Classic 12-Piece Bucket",
                              "category": "FESTIVE PARTY BUCKET",
                              "description": "Our iconic Hot & Crispy chicken, cooked golden brown and packed with flavour — 12 pieces of pure joy.",
                              "inStock": 1,
                              "price": 114190,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112339002"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936692",
                              "name": "Chicken & Strips Party Bucket",
                              "category": "FESTIVE PARTY BUCKET",
                              "description": "Double the fun! Mix of 10 juicy Hot & Crispy chicken and 10 tender chicken strips with 4 dips on the side.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/2e3a08e7-4f23-4c04-9267-fffb36b90c70_184bdd5a-02b6-4f8b-9c1a-ff159e3e4ad0.jpg",
                              "inStock": 1,
                              "price": 142761,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112339000"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936691",
                              "name": "Chicken Lovers Mega Bucket",
                              "category": "FESTIVE PARTY BUCKET",
                              "description": "For the real chicken lovers — 10 leg pieces & 10 Hot and Crispy chicken, all in one massive bucket.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/3e9c86e1-fde9-4539-8ac2-18fe8dea6111_0f828e0d-e319-4d0d-a1b9-400b471d731d.jpg",
                              "inStock": 1,
                              "price": 180857,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112338999"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936690",
                              "name": "Zinger Squad Meal",
                              "category": "FESTIVE PARTY BUCKET",
                              "description": "Perfect for your squad —  4 Classic Zingers, 4 med fries &  2 chilled Pepsi pet bottles",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/a0e13056-7e8d-418c-ae06-b9e0c56b75ac_9d2e6e48-aaa9-44dd-8b0e-9bdb649358b9.jpg",
                              "inStock": 1,
                              "price": 109428,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112339005"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184936689",
                              "name": "Classic Zinger Pack",
                              "category": "FESTIVE PARTY BUCKET",
                              "description": "All the crunch, spice & flavour of the legendary Classic Zinger — times six!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/0fb708e6-2251-4259-a6ba-b7e0144cfdda_eb46cacb-7d2a-4a83-907c-7c27223cf7bd.jpg",
                              "inStock": 1,
                              "price": 99904,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112339003"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/17/8282e629-3a22-45ca-a9fe-4eaed0639b2e_91bc2257-2f68-4958-9911-b07b31fc09b3.jpg",
                      "categoryId": "67961949"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "HOT & CRISPY CHICKEN & WINGS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896543",
                              "name": "Hot & Crispy Chicken - 8 pcs",
                              "category": "HOT & CRISPY CHICKEN & WINGS",
                              "description": "8 pc Hot & Cripsy",
                              "imageId": "uspplszjphtrwqn1alef",
                              "inStock": 1,
                              "price": 79900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247287749",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287755",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287759",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247287767",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54462668"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896541",
                              "name": "Hot & Crispy Chicken - 6 pcs",
                              "category": "HOT & CRISPY CHICKEN & WINGS",
                              "description": "6 pc signature Hot & crispy chicken",
                              "imageId": "ygv0a2rzffhnfgbfajz4",
                              "inStock": 1,
                              "price": 63900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288058",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288061",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288063",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288066",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "69513177"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896504",
                              "name": "Hot & Crispy Chicken - 4 pcs",
                              "category": "HOT & CRISPY CHICKEN & WINGS",
                              "description": "4 pcs of signature Hot & crispy chicken at a deal price",
                              "imageId": "m7q813n17jh4nrhtt7ss",
                              "inStock": 1,
                              "price": 44900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288314",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288316",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288320",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288323",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "101 ratings",
                                  "ratingCountV2": "101"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54462666"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896497",
                              "name": "Hot & Crispy Chicken- 2 pcs",
                              "category": "HOT & CRISPY CHICKEN & WINGS",
                              "description": "Get 2 piece Hot & Crispy Chicken",
                              "imageId": "n8ictcqllyfu5ojx3oci",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290960",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290962",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290963",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290965",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "144 ratings",
                                  "ratingCountV2": "144"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "28657429"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896495",
                              "name": "Hot Chicken Wings - 4 pcs",
                              "category": "HOT & CRISPY CHICKEN & WINGS",
                              "description": "Snack on the 4 pc Chicken Hot Wings Snack with your KFC Meal",
                              "imageId": "ubpofq5tlhdgwh2lzo8d",
                              "inStock": 1,
                              "price": 18500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245715174",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715178",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715181",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715182",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "187 ratings",
                                  "ratingCountV2": "187"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "69513176"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896494",
                              "name": "Hot & Crispy Chicken - 1 pc",
                              "category": "HOT & CRISPY CHICKEN & WINGS",
                              "description": "Get the 1piece Hot & Crispy Chicken",
                              "imageId": "scl1wyh0yg3saadaakbk",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436595",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436596",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436597",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436598",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "54 ratings",
                                  "ratingCountV2": "54"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "28657428"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "uspplszjphtrwqn1alef",
                      "categoryId": "44949354"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BONELESS CHICKEN POPCORN",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896500",
                              "name": "Chicken Popcorn - Large",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Large Pack of Chicken Popcorn seasoned with the Chili Lime flavours",
                              "imageId": "xwunbsyx5mjosb47pgpi",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245714775",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714779",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714784",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714787",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "248 ratings",
                                  "ratingCountV2": "248"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657120"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173654952",
                              "name": "Medium Chicken Popcorn & Pepsi Reusable",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Signature bite-sized boneless chicken - medium variant with Pepsi in a Reusable Bottle",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/9/a36ff2b2-2cc0-45c5-9808-e5fb6feec732_91f0bfb4-594d-434f-8d90-2f20ea7637de.jpg",
                              "inStock": 1,
                              "price": 27800,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "104803850"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896499",
                              "name": "Chicken Popcorn - Medium",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Medium Pack of Chicken Popcorn seasoned with the Chili Lime flavours",
                              "imageId": "vq4hhfaphd4fam2kieqq",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245715142",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715144",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715146",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245715148",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "286 ratings",
                                  "ratingCountV2": "286"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "54319289"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173654951",
                              "name": "2 x Medium Chicken Popcorn",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "2 units of Signature bite-sized boneless chicken, with special spices in Medium Size",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/9/b089959a-0ff6-4de9-b8bb-76db4579f3a7_25552e36-7c24-4d94-b3ff-939097ead631.jpg",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "104803845"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896498",
                              "name": "Chicken Popcorn - Regular",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Regular Pack of Chicken Popcorn seasoned with the Chili Lime flavours",
                              "imageId": "xzzsjnmakrosu2i5qatn",
                              "inStock": 1,
                              "price": 12500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "246436303",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436304",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436307",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "246436310",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "108 ratings",
                                  "ratingCountV2": "108"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "54462654"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "xwunbsyx5mjosb47pgpi",
                      "categoryId": "44949353"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "SIDES AND DIPS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170989230",
                              "name": "Gold Edition - Regular Fries",
                              "category": "SIDES AND DIPS",
                              "description": "Enjoy our Regular Fries Dipped in Cheesy Sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/14/6aea8e43-f8d0-401b-80fe-b1c4971b79bc_65aa8eb0-9be8-476f-8b7c-86ae59de4bae.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103405119"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896509",
                              "name": "Peri Peri Chicken Strips - 3 pc",
                              "category": "SIDES AND DIPS",
                              "description": "3 Pieces Spicy Peri Peri chicken boneless strips",
                              "imageId": "fgtsqzqqxxtzxu0p0acw",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245388129",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388132",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388135",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388138",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "94 ratings",
                                  "ratingCountV2": "94"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "64022827"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "161406236",
                              "name": "Peri Peri Chicken Leg Piece - 1 pc",
                              "category": "SIDES AND DIPS",
                              "description": "Crispy Chicken Leg Piece",
                              "imageId": "pss6auktmzkk1iaclhj2",
                              "inStock": 1,
                              "price": 11500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245945839",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945843",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945846",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245945848",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "87724680"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896492",
                              "name": "2 pc Veg Patty",
                              "category": "SIDES AND DIPS",
                              "description": "Delicious & Crispy 2 pc Veg patty ",
                              "imageId": "v9thnyukkkv47ifzmxfa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28656814"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896486",
                              "name": "French Fries - Large",
                              "category": "SIDES AND DIPS",
                              "description": "Large size Fries",
                              "imageId": "r93ljtqjnlpn2xr24dln",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290604",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290605",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290606",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290607",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "184 ratings",
                                  "ratingCountV2": "184"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54462659"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896485",
                              "name": "French Fries - Medium",
                              "category": "SIDES AND DIPS",
                              "description": "Medium size Fries",
                              "imageId": "n4ry9mep4uisjri10uqp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245088300",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245088301",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245088302",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245088304",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "148 ratings",
                                  "ratingCountV2": "148"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54462660"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896488",
                              "name": "Pack of 4 Dips",
                              "category": "SIDES AND DIPS",
                              "description": "Adding dips is always a good idea!",
                              "imageId": "gvtc5ybblsammx3nemfo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11000,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657638"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896487",
                              "name": "Pack of 2 Dips",
                              "category": "SIDES AND DIPS",
                              "description": "Adding dips is always a good idea!",
                              "imageId": "yblqo1sys6x3sdszulqq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657637"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896489",
                              "name": "Tandoori Flavour Dip - 20 gm",
                              "category": "SIDES AND DIPS",
                              "description": "Add Tandoori Masala Dip to your meal!",
                              "imageId": "icpcqoet1ssvzkvd4g3m",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "79430641"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/14/6aea8e43-f8d0-401b-80fe-b1c4971b79bc_65aa8eb0-9be8-476f-8b7c-86ae59de4bae.jpg",
                      "categoryId": "44949351"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "DESSERTS & BEVERAGES",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181067529",
                              "name": "KFC X Snickers Choco Mousse Cake",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Layers of smooth, gooey, nutty, chocolatey delight – with a Snickers twist.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/f078db6a-27c3-4738-a74e-2097fc6a710f_2f7120b2-49a3-44ed-9726-f14e32addc01.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "109740418"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237346",
                              "name": "Cold Coffee - Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Classic coffee just the way you like it! Served in Reusable Bottle",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/2941b251-8ed1-46f5-99bc-2161a7074518_b37ebbca-5b0a-44b3-8879-c593fd5c046e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89263203"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237344",
                              "name": "Virgin Mojito Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "All New Reusable Mojito Bottle 330ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/2c400914-f9a8-4364-95dc-39237e57ec58_b1ec722a-e668-4c17-8cc2-63727089a771.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89167241"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237339",
                              "name": "Dew Mojito Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "A refreshing drink with Mountain Dew, lime and soda to beat the heat",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/fa3a765b-0e7c-44ca-a7d6-9cf0711be53e_f28a7824-699d-4fa1-936a-7170e9c7ee4d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89263204"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237338",
                              "name": "Pepsi Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "New Reusable Pepsi Bottle 330ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/1af9ccc6-d64b-4345-86bf-a030427e5149_ee0c4915-6627-40ef-a2ce-9628d08f579d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89167240"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237337",
                              "name": "7Up Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "7Up in a KFC reusable bottle",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/20/f35c1655-ccc4-4eb9-9d14-0d3f7c36fa15_3976941b-923f-4f19-b381-6067c8e285e2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89263201"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237336",
                              "name": "Mirinda Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Mirinda in a KFC reusable bottle",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/14b5bbb5-ca27-4fac-abe3-004d94c7a319_75b050f5-1643-4b0e-86dc-0dcd4c8a7899.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89263207"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237335",
                              "name": "Mountain Dew Reusable Bottle",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Mountain Dew in a KFC reusable bottle",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/19/5a300a16-319e-4c09-ada8-42f6b33a6913_12b2f077-f9dd-4395-ac55-f1dbed1b6fe5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "89263209"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "100871968",
                              "name": "Choco Lava Cake",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Chocolate Goodness! Soft chocolate cake with lava oozing center",
                              "imageId": "thb7rrdooctsnknsnatz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "79430639"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896490",
                              "name": "Choco Mud Pie",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Hit the Dessert Spot with the KFC Choco Mud Pie- creamy layered cake",
                              "imageId": "fhtrvjerl7l2ck1crwhp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657230"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184578641",
                              "name": "Pepsi Can 330 ML",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657663"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184578640",
                              "name": "7up Can 330 ML",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "7UP is the ultimate Super-Duper Refresher. Every sip of this crisp lemon flavour refreshes you to the core.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28656909"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184578639",
                              "name": "Pepsi Can Black 330 ML",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Enjoy Pepsi Black to make your food rise up to max levels of awesome with Zero sugar and Zero guilt!",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112165077"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184578638",
                              "name": "Mirinda Can 330 ML",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Great orange taste and sparking bubbles encourage you to be carefree, spontaneous and playful!",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "28657540"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/f078db6a-27c3-4738-a74e-2097fc6a710f_2f7120b2-49a3-44ed-9726-f14e32addc01.jpg",
                      "categoryId": "44949350"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "B2G1 SPECIAL OFFER",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "177135925",
                              "name": "Gold Edition - Chicken Zinger Burger & Fries - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Relish our Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun with Pickles and Fries on the side",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "108862679"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "177135924",
                              "name": "Gold EditionVeg Zinger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Our Signature Veg Zinger Dunked in Cheese Sauce in the new Brioche Bun to get your tastebuds tingling",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "108862680"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521119",
                              "name": "Classic Chicken Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "American Signature Classic Chicken burger made with a crunchy chicken fillet, veggies & a delicious mayo sauce",
                              "imageId": "d5bc5b32dd177f5f207cad66556a572b",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486540"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521115",
                              "name": "Spicy Chicken Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Caribbean Spicy Zinger Burger with Spicy Bun & Spicy chilli sauce with Zinger Fillet, Lettuce, Onion and Tomatoes",
                              "imageId": "e3c645c8b5caa9c1b6374d88709e9e05",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486551"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521110",
                              "name": "Tandoori Chicken Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Zinger burger with a delicious Indian Tandoori flavour sauce",
                              "imageId": "af3699168db40a2dbadc372d87338e97",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486553"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521107",
                              "name": "Mexican Zinger Pro Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Premium Mexican Burger with crunchy chicken, Mexican Habanero sauce, cheese, tomato & onion",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/63e333fd-caa9-4032-9f1c-1799f26d5a45_2d9e58d4-6ad7-4acc-b58c-19f3f78acba9.jpg",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486548"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521101",
                              "name": "Paneer Veg Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Paneer Crunchy Patty Burger with tangy sauce and Veggies",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/56c5c073-4ac4-4c43-990e-16a558cf3877_87868b65-5a9c-4dd4-8f2e-e47ad6ee57d2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486549"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521097",
                              "name": "Vegetarian Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Veg Signature burger with crispy patties, veggies & a tangy sauce",
                              "imageId": "a403a55dc5b74cc6acfcfa755f30c165",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486557"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521093",
                              "name": "Cheese Classic Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "American Signature Classic Burger with a crunchy chicken fillet, cheese slice, veggies & a delicious mayo sauce",
                              "imageId": "418e7dc325cf65d7c1d9faab2e646421",
                              "inStock": 1,
                              "price": 23400,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486536"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521090",
                              "name": "Tandoori Cheese Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Chicken Zinger with aádelicious Indian tandoori flavour sauce & cheese slice",
                              "imageId": "7af6cdbf96ad445ebfce65f568fd0adf",
                              "inStock": 1,
                              "price": 24400,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486552"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521086",
                              "name": "Cheese Vegetarian Zinger Burger - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Veg Cheese Signature Burger with crispy patties, cheese slice, veggies & a tangy sauce",
                              "imageId": "6d8c645fcd7d5368741ccc61933fafed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22400,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486537"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521083",
                              "name": "American Classic Chicken Roll - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Roll with Layerful parantha, single chicken strip, onions and two spicy sauce",
                              "imageId": "ebd8e706049e4fd5ca79ecf708f8ecba",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486535"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521081",
                              "name": "Tandoori Indian Chicken Roll - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Roll made with flaky lachha paratha, perfectly fried chicken strips in rich and creamy tandoori sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/4c966f38-c191-4d0e-a54c-c70b832e4de1_69ee13c1-f267-4385-ab98-6efbc811de33.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486554"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521076",
                              "name": "Korean Chicken Tangy Roll - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Roll featuring delicious Tangy Korean kimchi, vegetables and crunchy chicken strips",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/377309f8-992e-4fea-a461-1ab5d7218b5e_b814bc78-3961-4332-96df-8aefb9ba86e4.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486543"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521072",
                              "name": "Thai Chicken Spicy Roll - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Roll featuring delicious Thai flavours and sauces in a flaky paratha, chicken strips and vegetables",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/fa48d82c-2322-4ba7-b419-27e79ca1b217_0800d19e-02b8-45e2-ad64-21ee0d877821.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486555"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521067",
                              "name": "Veg Indian Spicy Roll - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Special Veg spicy indian sauce and veggie roll",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/10/523afb1b-9bc9-4a4f-9c6e-1dda60b7da21_61c763cc-a9ca-4c13-ba15-3fe28d631b91.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486558"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521063",
                              "name": "Regular Popcorn Chicken - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Bite-sized signature boneless chicken, with special spices in Regular size",
                              "imageId": "ekczoyi57wriv1rqsmpl",
                              "inStock": 1,
                              "price": 12500,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486550"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521057",
                              "name": "Medium Popcorn Chicken - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Bite-sized signature boneless chicken, with special spices in Medium size",
                              "imageId": "ts7fhcu99uqvpo9nlxn5",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486547"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521053",
                              "name": "Large Popcorn Chicken - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Bite-sized signature boneless chicken, with special spices in Large size",
                              "imageId": "p6yghgzpqqlooi2lziyj",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486544"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521042",
                              "name": "Virgin Mojito Reusable Bottle - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Refreshing drink with lime and soda to beat the heat",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/2c400914-f9a8-4364-95dc-39237e57ec58_b1ec722a-e668-4c17-8cc2-63727089a771.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486559"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521036",
                              "name": "Dew Mojito Reusable Bottle - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Refreshing drink with Mountain Dew, lime and soda to beat the heat",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/fa3a765b-0e7c-44ca-a7d6-9cf0711be53e_f28a7824-699d-4fa1-936a-7170e9c7ee4d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486541"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521050",
                              "name": "Chicken Popcorn Rice Bowl - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Aromatic Rice Bowlz with chicken popcorn & gravy inside!",
                              "imageId": "9e57b3b9478a4a0b114b8ba4e1b5be89",
                              "price": 23000,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486538"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521048",
                              "name": "Grilled Smoky Rice Bowl - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Smoky Red Chicken aromatic Rice Bowl mixed with spicy gravy",
                              "imageId": "0c92428379d15d91c401e92044740d6e",
                              "price": 23000,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486542"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521046",
                              "name": "Classic Chicken Rice Bowl - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Hot & Crispy Chicken aromatic Rice Bowl mixed with spicy gravy inside",
                              "imageId": "a74de1a2b59bf60d616d458b7e78bd1a",
                              "price": 23000,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486539"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167521044",
                              "name": "Vegetarian Rice Bowl - DOTD",
                              "category": "B2G1 SPECIAL OFFER",
                              "description": "Veg aromatic Rice Bowl mixed with spicy gravy inside",
                              "imageId": "b55628a57b4ae927013617605d4db6e6",
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 2 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B2G1"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "B2G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B2G1",
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c963c647-d991-4cb1-8a6e-7bce72f9fccc"
                              ],
                              "parentId": "101486556"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "d5bc5b32dd177f5f207cad66556a572b",
                      "categoryId": "68051923"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "RICE BOWLZ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129529012",
                              "name": "Duo Popcorn Chicken Rice Bowl - Biryani Style",
                              "category": "RICE BOWLZ",
                              "description": "Save Rs. 30 on beloved Chicken Rice Bowlz served with signature Popcorn",
                              "imageId": "30eb3662da29c0e469299b2149aa4600",
                              "price": 42900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245290914",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290915",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139487046",
                                      "name": "Smoky Red Grilled Chicken - 1 pc",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290918",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245290919",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103616859"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129529014",
                              "name": "Classic Chicken Rice Bowl - Biryani Style",
                              "category": "RICE BOWLZ",
                              "description": "Rice Bowlz Attack!- Grab this aromatic Rice Bowlz rice with 1 piece Hot & Cripsy & gravy",
                              "imageId": "a74de1a2b59bf60d616d458b7e78bd1a",
                              "price": 23000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247005313",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005315",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005318",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247005321",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103616858"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129529015",
                              "name": "Smoky Red Chicken Rice Bowl - Biryani Style",
                              "category": "RICE BOWLZ",
                              "description": "Rice Bowlz Attack!- Grab this aromatic Rice Bowlz with smoky grilled chicken & gravy!",
                              "imageId": "3e243b6fbc280b8891643b1d3b7836f6",
                              "price": 23000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245388391",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388393",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388400",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388406",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103616861"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129529016",
                              "name": "Popcorn Chicken Rice Bowl - Biryani Style",
                              "category": "RICE BOWLZ",
                              "description": "Rice Bowlz Attack!- Grab this aromatic Rice Bowlz with chicken popcorn & gravy!",
                              "imageId": "9e57b3b9478a4a0b114b8ba4e1b5be89",
                              "price": 23000,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245388964",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388965",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388967",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245388970",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103616860"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129529017",
                              "name": "Veg Rice Bowl - Biryani Style",
                              "category": "RICE BOWLZ",
                              "description": "Rice Bowlz Attack!- Grab this aromatic Rice Bowlz with gravy now!",
                              "imageId": "b55628a57b4ae927013617605d4db6e6",
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288621",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "139487045",
                                      "name": "Veg Zinger Burger with Cheese",
                                      "price": 22400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133636998",
                                      "name": "Paneer Zinger Burger",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288625",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288627",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "103616862"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129529019",
                              "name": "Plain Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "Aromatic Plain Rice- perfect go along to make a wholesome meal!",
                              "imageId": "38c021b7322ea7451ad6668b1e0706be",
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245714475",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714476",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714479",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714481",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "75280051"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "30eb3662da29c0e469299b2149aa4600",
                      "categoryId": "43756634"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "GRILLED SMOKY RED CHICKEN",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156237347",
                              "name": "5 Pc Smoky Chicken Mojito Combo",
                              "category": "GRILLED SMOKY RED CHICKEN",
                              "description": "Get All New Mojito Reusable Bottle with 5 Pc Smoky Red Grilled Chicken",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/5821392c-8d91-4783-b2c0-d137f328ae51_0523173e-da76-419b-b2e3-ee35a91b1921.jpg",
                              "price": 62800,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288842",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288848",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288852",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288855",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "80357455"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896540",
                              "name": "Smoky Red Grilled Chicken - 5 pc",
                              "category": "GRILLED SMOKY RED CHICKEN",
                              "description": "Grab 5 pc Smoky Red Chicken - grilled to perfection",
                              "imageId": "ewi33xnqju9f6ezzwhbk",
                              "price": 54900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247289211",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289216",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289219",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247289224",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "56426960"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896496",
                              "name": "Smoky Red Grilled Chicken - 2 pc",
                              "category": "GRILLED SMOKY RED CHICKEN",
                              "description": "Savour 2 pieces of KFC Smoky Red Chicken- Hot Grilled Chicken Leg Piece!",
                              "imageId": "e2gbhuf1hprednohf5yt",
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "247288676",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288681",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288686",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "247288689",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "63453078"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99896493",
                              "name": "Smoky Red Grilled Chicken - 1 pc",
                              "category": "GRILLED SMOKY RED CHICKEN",
                              "description": "1pc smoky grilled chicken",
                              "imageId": "wfmeqvdcmqmv1wpshbqh",
                              "price": 12500,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "245714239",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "112325588",
                                      "name": "French Fries - Large",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325590",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139921679",
                                      "name": "Gold Edition - Regular Fries",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325627",
                                      "name": "Tandoori Flavour Dip - 20 gm",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325595",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325603",
                                      "name": "French Fries - Medium",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585472",
                                      "name": "Plain Rice Bowlz",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714248",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "112325582",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585477",
                                      "name": "Classic Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585476",
                                      "name": "Korean Tangy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585478",
                                      "name": "Thai Spicy Chicken Roll",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554452",
                                      "name": "Chicken Zinger Burger - Classic",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554451",
                                      "name": "Indian Tandoori Chicken Roll",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325587",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 18500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "116074053",
                                      "name": "Peri Peri Chicken Strips - 3 pc",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585483",
                                      "name": "Spicy Zinger Burger",
                                      "price": 22900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714252",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "133554449",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133585485",
                                      "name": "Virgin Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "133554450",
                                      "name": "Dew Mojito Reusable Bottle",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "245714254",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "112325586",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "112325584",
                                      "name": "Choco Mud Pie",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139862094",
                                      "name": "KFC X Snickers Choco Mousse Cake",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "56426958"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/5821392c-8d91-4783-b2c0-d137f328ae51_0523173e-da76-419b-b2e3-ee35a91b1921.jpg",
                      "categoryId": "52917106"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": ["License No. 11222333001255"]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "KFC",
                      "area": "Central Bangalore",
                      "completeAddress": "Ground Floor & 1st Floor, Brigade Rd, Opposite Space Centre, Shanthala Nagar, Ashok Nagar, Bengaluru, Karnataka 560029"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "5602e80c-1150-421a-bc1f-8b77629c13f3",
  "sid": "njx5e737-2f48-4587-8e80-c66b72c5229f",
  "deviceId": "ad4d38e2-4f9c-8120-c670-5a2d42f94301",
  "csrfToken": "GYfbtdtcIga0-PWrVn3eMar2l9CJhThDMEcSSWAc"
}
